import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { MatTableDataSource, MatPaginator, MatSort, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import * as XLSX from 'xlsx';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosRepFinanzas } from 'app/models/FiltrosRepFinanzas';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs/Rx';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-kpi-deudor',
  templateUrl: './kpi-deudor.component.html',
  styleUrls: ['./kpi-deudor.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class KpiDeudorComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['NUMERO_OPERACION', 'CODIGO_ORDEN',
    'EJECUT',
    'RUC_CLIENTE',
    'RAZON_SOCIAL_CLIENTE', 'CODIGO_FN',
    'FACTURA_NEGOCIADA',
    'VALOR_NOMINAL',
    'RUC_DEUDOR',
    'RAZON_SOCIAL_DEUDOR',
    'MONEDA',
    'TEM', 'TASA_ALL_IN', 'TC',
    'FECHA_OPERACION',
    'FECHA_VENCIMIENTO', 'DIAS_ATRASO', 'INTERESES_DESCONTADOS', 'COMISION_ESTRUCTURACION', 'IGV_COMISION_ESTRUCTURACION', 'IGV_INTERES_DESCONTADOS', 'TOTAL_DESCUENTO', 'CAVALI', 'FIRMA_ELECTRONICA', 'OTROS', 'IGV', 'TOTAL_COSTOS', 'RETENCION'];
  headerStyle: any = [
    { cell: 'A2', cells: 'A1:A2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'B2', cells: 'B1:B2', fgColor: 'FFC000', color: 'FFFFFF' },
    { cell: 'C2', cells: 'C1:C2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'D2', cells: 'D1:D2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'E2', cells: 'E1:E2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'F2', cells: 'F1:F2', fgColor: 'FFC000', color: 'FFFFFF' },
    { cell: 'G2', cells: 'G1:G2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'H2', cells: 'H1:H2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'I2', cells: 'I1:I2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'J2', cells: 'J1:J2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'K2', cells: 'K1:K2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'L2', cells: 'L1:L2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'M2', cells: 'M1:M2', fgColor: 'FFC000', color: 'FFFFFF' },
    { cell: 'N2', cells: 'N1:N2', fgColor: 'FFC000', color: 'FFFFFF' },
    { cell: 'O2', cells: 'O1:O2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'P2', cells: 'P1:P2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'Q2', cells: 'Q1:Q2', fgColor: 'FFC000', color: 'FFFFFF' },
    { cell: 'R1', cells: 'R1:V1', fgColor: '00B0F0', color: 'FFFFFF', title: 'INTERESES & COMISIONES' },
    { cell: 'R2', fgColor: '00B0F0', color: 'FFFFFF' },
    { cell: 'S2', fgColor: '00B0F0', color: 'FFFFFF' },
    { cell: 'T2', fgColor: '00B0F0', color: 'FFFFFF' },
    { cell: 'U2', fgColor: '00B0F0', color: 'FFFFFF' },
    { cell: 'V2', fgColor: '00B0F0', color: 'FFFFFF' },
    { cell: 'W1', cells: 'W1:AA1', fgColor: '002060', color: 'FFFFFF', title: 'COSTOS DE OPERACIÓN' },
    { cell: 'W2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'X2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'Y2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'Z2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'AA2', fgColor: '002060', color: 'FFFFFF' },
    { cell: 'AB2', cells: 'AB1:AB2', fgColor: '002060', color: 'FFFFFF' },
  ];
  footerStyle: any = [
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF', content: 'TOTAL' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF', formula: 'SUM', col: 'H' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: 'FFC000', color: 'FFFFFF', content: 'PPP TEM' },
    { fgColor: 'FFC000', color: 'FFFFFF', content: 'PPP TASA ALL IN' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF', formula: 'SUM', col: 'R' },
    { fgColor: 'FF5050', color: 'FFFFFF', formula: 'SUM', col: 'S' },
    { fgColor: 'FF5050', color: 'FFFFFF', formula: 'SUM', col: 'T' },
    { fgColor: 'FF5050', color: 'FFFFFF', formula: 'SUM', col: 'U' },
    { fgColor: '808080', color: 'FFFFFF', formula: 'SUM', col: 'V' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF' },
    { fgColor: '808080', color: 'FFFFFF', formula: 'SUM', col: 'AA' },
    { fgColor: 'FF5050', color: 'FFFFFF', formula: 'SUM', col: 'AB' },
  ]
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  loadingUser: boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any = [];
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepFinanzas: Subscription = new Subscription();
  DTOFiltrosRepFinanzas: FiltrosRepFinanzas = new FiltrosRepFinanzas();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  proveedoresArr;
  Fruc = new FormControl();
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'comercial';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  label_Soles = environment.ID_MONEDA_SOLES;
  label_Dolares = environment.ID_MONEDA_DOLARES;
  label_Factoring = environment.ID_FACTORING;
  label_Confirming = environment.ID_CONFIRMING;
  label_Proveedor = environment.LABEL_PROVEEDOR;
  label_Adquirente = environment.LABEL_ADQUIRENTE;
  id = '';
  idAd = '';
  filteredProveeedor: Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;
  adquirentesArr;
  ruc = new FormControl();
  rucAd = new FormControl();
  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus) { }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.obtenerListaAccesos();
    //this.ListadoRepFinanzas();
    this.id = '';
    this.idAd = '';
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
    this.securityService.headerStyle = this.headerStyle;
    this.securityService.footerStyle = this.footerStyle;
    this.securityService.displayedColumns = this.displayedColumns;
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepFinanzas() {
    this.loading = true;
    this.DTOFiltrosRepFinanzas.Tipo = 'kpi_obligado';
    this.subRepFinanzas = this.securityService.FiltroListadoRepFinanzas(this.DTOFiltrosRepFinanzas, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        if (this.dataSource.length === 0) {
          this.dataSource = new MatTableDataSource(this.dataReporte["operaciones"]);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte["operaciones"];
        this.securityService.dataPropertiesBuffer = this.dataReporte["propiedades"];
        if ((this.DTOFiltrosRepFinanzas.Adquirente !== '')) {
          this.DescargaReporte();
        }
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepFinanzas.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);
  }
  seleccionarMoneda(event) {
    this.DTOFiltrosRepFinanzas.Moneda = event;
    return;
  }
  seleccionarProveedor(event) {
    this.DTOFiltrosRepFinanzas.Proveedor = event;
    return;
  }
  seleccionarAdquirente(event) {
    this.DTOFiltrosRepFinanzas.Adquirente = event;
    return;
  }
  seleccionarProducto(event) {
    this.DTOFiltrosRepFinanzas.Producto = event;
    return;
  }
  obtenerRucRazSocial(termino: string = '') {

    if (termino != null && termino != '') {

      let termino1 = termino.toLowerCase();

      for (let p of this.proveedoresArr) {

        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {

          this.id = p.Num_Doc_Identificacion;
        }

      }

    }

  }
  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }
  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }
  obtenerId(termino: string) {
    this.id = termino;
  }
  obtenerIdAd(termino: string) {
    this.idAd = termino;
  }
  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAd.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.adquirentesArr.slice()
        )
      );

  }
  obtenerRucRazSocialAdquirentes(termino: string = '') {

    if (termino != null && termino != '') {


      let termino1 = termino.toLowerCase();

      for (let p of this.adquirentesArr) {

        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {

          this.idAd = p.Num_Doc_Identificacion;
        }

      }

    }

  }
  deleteFiltro(title) {
    switch (title) {
      case 'Adquirente':
        this.rucAd.setValue('');
        this.DTOFiltrosRepFinanzas.Adquirente = '';
        break;
      case 'Proveedor':
        this.ruc.setValue('');
        this.DTOFiltrosRepFinanzas.Proveedor = '';
        break;
    }
  }

  DescargaReporte() {
    const workbooks = new ExcelJS.Workbook();
    const worksheets = workbooks.addWorksheet('Report');
    let typeName = "";
    /*if (this.DTOFiltrosRepFinanzas.Proveedor !== "") {
      this.LoadClienteReport(worksheets);
      typeName = 'Cliente'
    }*/
    if (this.DTOFiltrosRepFinanzas.Adquirente !== "") {
      this.LoadObligadoReport(worksheets);
      typeName = 'Obligado'
    }

    // Generate Excel file
    workbooks.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Reporte_Finanzas_' + typeName + '.xlsx');
    });
  }
  LoadClienteReport(worksheets) {
    //Cliente
    const tableCLiente = [
      { cell: 'B2', content: 'CODIGO CLIENTE:', style: 'bold' },
      { cell: 'B3', content: 'RAZON SOCIAL:', style: 'bold' },
      { cell: 'B4', content: 'RUC:', style: 'bold' },
      { cell: 'B5', content: 'DIRECCIÓN:', style: 'bold' },
      { cell: 'B6', content: 'TELEFONO:', style: 'bold' },
      { cell: 'J2', content: 'CLASIFICACIÓN', style: 'bold' },
      { cell: 'J3', content: 'SBS', style: 'border' },
      { cell: 'J4', content: 'SENTINEL', style: 'border' },
      { cell: 'K3', content: '(COLOR)', style: 'border' },
      { cell: 'K4', content: 'PUNTAJE (COLOR)', style: 'border' },
      //Tabla1
      { cell: 'D8', content: 'DEUDOR', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'E8', content: 'Tope Aprobado', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'F8', content: 'Utilizado', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'G8', content: 'Disponible', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'H8', content: 'Porcentaje', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      //Tabla2
      { cell: 'B11', content: 'N° DE OPERACIÓN', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'C11', content: 'N° RUC', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'D11', content: 'DEUDOR', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'E11', content: 'MONEDA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'F11', content: 'PRODUCTO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'G11', content: 'N° FACTURA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'H11', content: 'TASA DE INTERES', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'I11', content: 'VALOR NOMINAL', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'J11', content: 'FECHA DE OP', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'K11', content: 'FECHA DE VENC', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'L11', content: 'FECHA DE PAGO REPROGRAMACIÓN', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'M11', content: 'FECHA DE PAGO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'N11', content: 'DIAS DE MORA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'O11', content: 'ESTADO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'P11', content: 'ESTADO DE RETENCIÓN', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'Q11', content: 'FECHA DE DEVOLUCION', Bcolor: '002060', color: 'FF0000', style: 'border,center,bold' }
    ]
    const dataHead1 = [
      'CODIGO_FN', 'RAZON_SOCIAL_CLIENTE', 'RUC_CLIENTE', 'MONEDA', 'TIPO_SERVICIO'
    ];
    const dataHead2 = [
      'RAZON_SOCIAL_DEUDOR', 'RAZON_SOCIAL_CLIENTE', 'RUC_CLIENTE', 'MONEDA', 'TIPO_SERVICIO'
    ];
    const dataHead3 = [
      'NUMERO_OPERACION', 'RUC_CLIENTE', 'RAZON_SOCIAL_DEUDOR', 'MONEDA', 'TIPO_SERVICIO', 'FACTURA_NEGOCIADA', 'TASA_ALL_IN', 'VALOR_NOMINAL', 'FECHA_OPERACION', 'FECHA_VENCIMIENTO', 'FECHA_VENCIMIENTO', 'FECHA_VENCIMIENTO', 'DIAS_ATRASO', 'DIAS_ATRASO', 'TIPO_SERVICIO', 'FECHA_VENCIMIENTO'
    ];
    const footerCliente = [
      { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: 'TOTAL SALDO VIGENTE', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', formula: 'SUM', Bcolor: 'BFBFBF', col: 'I' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }
    ]
    let data = this.securityService.dataBuffer;
    tableCLiente.forEach((el, index) => {
      worksheets.getCell(el.cell).value = el.content;
      worksheets.getColumn(index + 2).width = 15;
      if (el.style) {
        if (String(el.style).includes('bold')) {
          worksheets.getCell(el.cell).font = {
            bold: true,
            underline: String(el.style).includes('underline') ? true : false,
            color: { argb: el.color ? el.color : null },
          }
        }
        if (String(el.style).includes('border')) {
          worksheets.getCell(el.cell).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
        }
        if (String(el.style).includes('center')) {
          worksheets.getCell(el.cell).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        }
      }
      if (el.color) {
        worksheets.getCell(el.cell).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: el.Bcolor }
        };
      }


    });
    let fila1 = 2;
    let colum1 = 3;
    
    dataHead1.forEach((header, ind) => {
      const rows = worksheets.getRow(ind + fila1);
      rows.getCell(colum1).value = data[0][header];
    });


    let fila2 = 9;
    let colum2 = 4;
    const rows = worksheets.getRow(fila2);
    dataHead2.forEach((header, ind) => {
      rows.getCell(ind + colum2).value = data[0][header];
      rows.getCell(ind + colum2).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });


    let fila3 = 12;
    let colum3 = 2;
    data.forEach((item, index) => {
      const rows = worksheets.getRow(index + fila3);
      dataHead3.forEach((header, ind) => {
        if (header == 'VALOR_NOMINAL') {
          rows.getCell(ind + colum3).value = Number(item[header]);
        } else {
          rows.getCell(ind + colum3).value = item[header];
        }
        rows.getCell(ind + colum3).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

    });
    footerCliente.forEach((footer, ind) => {
      const rows = worksheets.getRow(fila3 + data.length);
      rows.getCell(colum3 + ind).value = footer.formula ? { formula: `${footer.formula}(${footer.col}${fila3}:${footer.col}${fila3 + data.length - 1})`, date1904: false } : footer.content;
      rows.getCell(colum3 + ind).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: footer.Bcolor }
      };

    });
  }
  LoadObligadoReport(worksheets) {
    //Obligado
    
    let data = this.securityService.dataBuffer;
    let dataProperties = this.securityService.dataPropertiesBuffer;
    const tableObligado = [
      { cell: 'B2', content: 'CODIGO OBLIGADO:', style: 'bold' },
      { cell: 'B3', content: 'RAZON SOCIAL:', style: 'bold' },
      { cell: 'B4', content: 'RUC:', style: 'bold' },
      { cell: 'B5', content: 'DIRECCIÓN:', style: 'bold' },
      { cell: 'B6', content: 'TELEFONO:', style: 'bold' },
      { cell: 'L2', content: 'CLASIFICACIÓN', style: 'bold' },
      { cell: 'L3', content: 'SBS', style: 'border' },
      { cell: 'L4', content: 'SENTINEL', style: 'border' },
      { cell: 'M3', content: '-', style: 'border' },
      { cell: 'M4', content: dataProperties[0]["SCORE_PUNTAJE"], style: 'border' },
      //Tabla1
      { cells: 'E2:F2', cell: 'E2', content: 'CONTROL LINEA OBLIGADO', Bcolor: '002060', color: 'FFFFFF', style: 'center,bold' },
      { cell: 'E3', content: 'LINEA APROBADA', style: 'center' },
      { cell: 'E4', content: 'UTILIZADA', style: 'center' },
      { cell: 'E5', content: 'DISPONIBLE', Bcolor: 'F2F2F2', style: 'center,bold' },
      //Tabla2
      { cells: 'H2:I2', cell: 'H2', content: 'CONTROL LINEA GRUPO ECONOMICO', Bcolor: '002060', color: 'FFFFFF', style: 'center,bold' },
      { cell: 'H3', content: 'LINEA APROBADA', style: 'center' },
      { cell: 'H4', content: 'UTILIZADA', style: 'center' },
      { cell: 'H5', content: 'DISPONIBLE', Bcolor: 'F2F2F2', style: 'center,bold' },
      //Tabla3
      { cell: 'B8', content: 'N° DE OPERACIÓN', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'C8', content: 'N° RUC', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'D8', content: 'PROVEEDOR', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'E8', content: 'MONEDA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'F8', content: 'PRODUCTO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'G8', content: 'N° FACTURA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'H8', content: 'TASA DE INTERES', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'I8', content: 'VALOR NOMINAL', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'J8', content: 'FECHA DE OP', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'K8', content: 'FECHA DE VENC', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'L8', content: 'FECHA DE PAGO (R)', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'M8', content: 'FECHA DE PAGO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'N8', content: 'DIAS DE MORA', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' },
      { cell: 'O8', content: 'ESTADO', Bcolor: '002060', color: 'FFFFFF', style: 'border,center,bold' }
    ];
    const dataHead1 = [
      'ID_OBLIGADO', 'RAZON_SOCIAL_OBLIGADO', 'RUC_OBLIGADO', 'DIRECCION_OBLIGADO', 'TELEFONO_OBLIGADO'
    ];
    const dataHead2 = [
      'LINEA_ADMITIDA', 'LINEA_UTILIZADA', 'LINEA_DISPONIBLE'
    ];
    const dataHead3 = [
      'LINEA_ADMITIDA_GRUPO', 'LINEA_UTILIZADA_GRUPO', 'LINEA_DISPONIBLE_GRUPO'
    ];
    const dataHead4 = [
      'NUMERO_OPERACION', 'RUC_DEUDOR', 'RAZON_SOCIAL_DEUDOR', 'MONEDA', 'TIPO_SERVICIO', 'FACTURA_NEGOCIADA', 'TASA_ALL_IN', 'VALOR_NOMINAL', 'FECHA_OPERACION', 'FECHA_VENCIMIENTO', 'FECHA_VENCIMIENTO', 'FECHA_VENCIMIENTO', 'DIAS_ATRASO', 'FECHA_VENCIMIENTO'
    ];
    const footerObligado = [
      { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: 'TOTAL SALDO VIGENTE', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', formula: 'SUM', Bcolor: 'BFBFBF', col: 'I' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }, { content: '', Bcolor: 'BFBFBF' }
    ]
    tableObligado.forEach((el, index) => {
      worksheets.getCell(el.cell).value = el.content;
      worksheets.getColumn(index + 2).width = 15;
      if (el.cells) {
        worksheets.mergeCells(String(el.cells));
      }
      if (el.style) {
        if (String(el.style).includes('bold')) {
          worksheets.getCell(el.cell).font = {
            bold: true,
            underline: String(el.style).includes('underline') ? true : false,
            color: { argb: el.color ? el.color : null },
          }
        }
        if (String(el.style).includes('border')) {
          worksheets.getCell(el.cell).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
        }
        if (String(el.style).includes('center')) {
          worksheets.getCell(el.cell).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        }
      }
      if (el.color) {
        worksheets.getCell(el.cell).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: el.Bcolor }
        };
      }


    });
    let fila1 = 2;
    let colum1 = 3;
    let flagScore ='81806D';
    if(dataProperties[0]["SCORE_NIVEL"] == 1){
      flagScore ='E40A0A';
    }else if(dataProperties[0]["SCORE_NIVEL"] == 2){
      flagScore ='EEEE00';
    }else{
      flagScore ='00CC00';
    }
    worksheets.getCell('K4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: flagScore }
    };
    dataHead1.forEach((header, ind) => {
      const rows = worksheets.getRow(ind + fila1);
      rows.getCell(colum1).value = dataProperties[0][header];
    });
    let fila2 = 3;
    let colum2 = 6;

    dataHead2.forEach((header, ind) => {
      const rows = worksheets.getRow(ind + fila2);
      rows.getCell(colum2).value = dataProperties[0][header];
    });

    let fila3 = 3;
    let colum3 = 9;

    dataHead3.forEach((header, ind) => {
      const rows = worksheets.getRow(ind + fila3);
      rows.getCell(colum3).value = dataProperties[0][header];
    });

    let fila4 = 9;
    let colum4 = 2;
    data.forEach((item, index) => {
      const rows = worksheets.getRow(index + fila4);
      dataHead4.forEach((header, ind) => {
        if (header == 'VALOR_NOMINAL') {
          rows.getCell(ind + colum4).value = Number(item[header]);
        } else {
          rows.getCell(ind + colum4).value = item[header];
        }
        rows.getCell(ind + colum4).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

    });


    footerObligado.forEach((footer, ind) => {
      const rows = worksheets.getRow(fila4 + data.length);
      rows.getCell(colum4 + ind).value = footer.formula ? { formula: `${footer.formula}(${footer.col}${fila4}:${footer.col}${fila4 + data.length - 1})`, date1904: false } : footer.content;
      rows.getCell(colum4 + ind).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: footer.Bcolor }
      };

    });

  }
}
